export default __webpack_public_path__ + "static/clara-mesa-2dcb3c05c373acdb8c5d196ebd5af605.png";